import { useQuery } from '@tanstack/react-query';
import { CommonApiService, CityOption } from '../../../services/commonApi';

/** City options for the vendor filter + add/edit form dropdowns. */
export const useCities = () => {
	return useQuery({
		queryKey: ['common', 'cities'],
		queryFn: async (): Promise<CityOption[]> => {
			const res = await CommonApiService.getCities();
			return (res?.data ?? []) as CityOption[];
		},
		staleTime: 5 * 60 * 1000, // cities rarely change
		refetchOnWindowFocus: false,
	});
};
